import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=704634ce&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=704634ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704634ce",
  null
  
)

export default component.exports